export const TEAMS_CONFIGURATION_SUCCESS = 'TEAMS_CONFIGURATION_SUCCESS';
export const TEAMS_CONFIGURATION_ERROR = 'TEAMS_CONFIGURATION_ERROR';
export const TEAMS_CONFIGURATION_LOADING = 'TEAMS_CONFIGURATION_LOADING';
export const TEAMS_CONFIGURATION_DELETED = 'TEAMS_CONFIGURATION_DELETED';
